import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { sentryTools } from '@q-front-npm/tools';
import { jsbSupportMap, getUserInfo as jsbGetUserInfo } from '@q-front-npm/jsbridge';

export interface ISentryConfig {
    dsn: string;
    name: string;
    version: string;
}

export const initSentry = async(config: ISentryConfig) => {
    if (import.meta.env.VITE_ENV === 'dev') {
        return;
    }
    try {
        Sentry.init({
            Vue: Vue,
            dsn: config.dsn || 'https://f1c3c4083f7848d4acfc7ac7423930f3@qm-front-sentry.wtzw.com/63',
            release: `${config.name}@${config.version}`,
            integrations: [Sentry.browserTracingIntegration()],
            autoSessionTracking: true,
            environment: import.meta.env.VITE_ENV,
            tracesSampleRate: import.meta.env.VITE_ENV === 'test' ? 1.0 : 0.1,
            ignoreErrors: ['ResizeObserver loop limit exceeded', /chrome-extension:\/\//, /moz-extension:\/\//, /safari-extension:\/\//, 'Script error.', 'Non-Error promise rejection captured', 'AdBlocker', 'uBlock', 'Adblock', 'SecurityError: Permission denied'],
            beforeSend(event, hint) {
                if (sentryTools.checkExtensionRelated(event)) {
                    return null;
                }
                if ((hint.originalException as Error)?.message?.includes('app版本不支持当前')) {
                    return null;
                }
                return event;
            },
        });
        if (jsbSupportMap.user.getUserInfo) {
            const res = await jsbGetUserInfo('id');
            Sentry.setTag('uid', res.id);
        }
    } catch (er) {
        // 防止sentry初始化失败，不抛出错误
    }
};
